import { Stack } from "@mui/material";
import { AnalyticCardWrapper } from "../AnalyticCardWrapper";
import { EngagementRate } from "../EngagementRate";
import { RateIndicator } from "../../../../types/enums";

export const AccountAverageRateBlock = ({
  value,
  indicator,
  indicatorChange,
  indicatorChangeAt,
}: {
  value: number;
  indicator?: RateIndicator;
  indicatorChange?: number;
  indicatorChangeAt?: string;
}) => {
  return (
    <AnalyticCardWrapper
      title="Engagement Rate"
      tooltip="Average engagement rate of all identified BC within this account. Engagement rate refers to how
      active and efficient the communication with identified BC members is, based on phone calls, emails, meetings,
       and communication recency data."
    >
      <Stack alignItems="center" justifyContent="center" flexGrow={1}>
        <EngagementRate
          value={value}
          indicator={indicator}
          indicatorChange={indicatorChange}
          indicatorChangeAt={indicatorChangeAt}
        />
      </Stack>
    </AnalyticCardWrapper>
  );
};
